export default __webpack_public_path__ + "static/media/undraw_notify_88a4.646ca234.svg";